import { useQuery } from '@tanstack/react-query';
import { customerCreditsService } from '@/services/customer/credits.service';
import type { CustomerCreditHistoryRecord, CustomerCreditsBalance } from '@/types/customer-credits';

const customerCreditsKeys = {
  all: ['customer-credits'] as const,
  balance: () => [...customerCreditsKeys.all, 'balance'] as const,
  history: () => [...customerCreditsKeys.all, 'history'] as const,
  expiring: (days: number) => [...customerCreditsKeys.all, 'expiring', days] as const,
};

export function useCustomerCreditsBalance() {
  return useQuery<CustomerCreditsBalance>({
    queryKey: customerCreditsKeys.balance(),
    queryFn: () => customerCreditsService.getBalance(),
    staleTime: 60 * 1000,
  });
}

export function useCustomerCreditsHistory() {
  return useQuery<CustomerCreditHistoryRecord[]>({
    queryKey: customerCreditsKeys.history(),
    queryFn: () => customerCreditsService.getHistory(),
    staleTime: 60 * 1000,
  });
}

export function useCustomerCreditsExpiring(days = 30) {
  return useQuery<{ records: CustomerCreditHistoryRecord[]; days: number }>({
    queryKey: customerCreditsKeys.expiring(days),
    queryFn: () => customerCreditsService.getExpiring(days),
    staleTime: 60 * 1000,
  });
}
